import Cookies from "js-cookie";
import axios from "axios";
import API_BASE_URL from "../../config/runtimeConfig";

const API_BASE = `${API_BASE_URL}/api/Metadata/`;
const headers = { "Content-Type": "application/json" };

const getToken = () => Cookies.get("employeeToken") || "";

// Get Functions ID
export const getFunctions = async () => {
  try {
    const response = await axios.post(
      `${API_BASE}GetFunctions`,
      { token: getToken() },
      { headers }
    );
    return response.data.functionDataList || [];
  } catch {
    return [];
  }
};

// Get Functions Manager Name
export const getFunctionName = async (functionID) => {
  try {
    const response = await axios.post(
      `${API_BASE}GetFunctions`,
      {
        token: getToken(),
        functionID: parseInt(functionID),
      },
      { headers }
    );
    return response.data.functionDataList || [];
  } catch {
    return [];
  }
};

// Get Grades
export const getGrades = async () => {
  try {
    const response = await axios.post(
      `${API_BASE}GetGrades`,
      { token: getToken() },
      { headers }
    );
    return response.data.gradeList || [];
  } catch{
    return [];
  }
};

// Get Zones
export const getZones = async () => {
  try {
    const response = await axios.post(
      `${API_BASE}GetZones`,
      { token: getToken() },
      { headers }
    );
    return response.data.zoneDataList || [];
  } catch {
    return [];
  }
};

// Get Departments based on Function ID
export const getDepartments = async (functionID) => {
  try {
    const response = await axios.post(
      `${API_BASE}GetDepartments`,
      {
        token: getToken(),
        function: parseInt(functionID),
      },
      { headers }
    );
    return response.data.departmentList || [];
  } catch{
    return [];
  }
};

// Get Job Locations
export const getJobLocations = async (zoneId) => {
  try {
    const response = await axios.post(
      `${API_BASE}GetJobLocations`,
      {
        token: getToken(),
        zone: parseInt(zoneId),
      },
      { headers }
    );
    return response.data.jobLocationList || [];
  } catch {
    return [];
  }
};

// Get Role Type
export const getRoleType = async () => {
  try {
    const response = await axios.post(
      `${API_BASE}GetRoleType`,
      { token: getToken() },
      { headers }
    );
    return response.data.roleType || [];
  } catch {
    return [];
  }
};

// Harshada Bhavsar - (20/02/2026)
export const getGenderType = async () => {
  try {
    const response = await axios.get(`${API_BASE}GetGenderType`);
    return response.data.genderType || [];

  } catch (error) {
    return [];
  }
};

// Get Role Type
export const getJobCategory = async () => {
  try {
    const response = await axios.post(
      `${API_BASE}GetJobCategory`,
      { token: getToken() },
      { headers }
    );
    return response.data.jobCategory || [];
  } catch{
    return [];
  }
};

// Get Employee Details
export const getEmployeeDetails = async (employeeCode) => {
  try {
    const response = await axios.post(
      `${API_BASE}GetEmployeeDetails`,
      { token: getToken(), employeeCode },
      { headers }
    );
    return response.data.userDetails || null;
  } catch {
    return null;
  }
};

// Get Consultant Details
export const getConsultantDetails = async (consultantCode) => {
  try {
    const response = await axios.post(
      `${API_BASE}GetConsultantDetails`,
      { token: getToken(), consultantCode },
      { headers }
    );
    return response;
  } catch {
    return null;
  }
};

//Harshada Bhavsar (24/7/2025)
// Get Consultant Types API
export const getConsultantTypes = async () => {
  try {
    const response = await axios.post(
      `${API_BASE}GetConsultantType`,
      { token: getToken() },
      { headers }
    );
    return response.data.consultantTypeList || [];
  } catch {
    return [];
  }
};

//Get Answer Types
export const GetAnswerTypes = async () => {
  try {
    const response = await axios.post(
      `${API_BASE}GetAnswerType`,
      { token: getToken() },
      { headers }
    );
    return response.data.answerType || [];
  } catch {
    return [];
  }
};

//Get Employee Suggestions by searching the name
export const getEmployeeSuggestions = async (searchParameter) => {
  try {
    const response = await axios.post(
      `${API_BASE}GetEmployeeSuggestions`,
      { token: getToken(), searchParameter },
      { headers }
    );
    return response.data.employeeSuggestions || [];
  } catch {
    return [];
  }
};

//Get Employee Suggestions by searching the name
export const getConsultantSuggestions = async (searchParameter) => {
  try {
    const response = await axios.post(
      `${API_BASE}GetConsultantSuggestions`,
      { token: getToken(), searchParameter },
      { headers }
    );
    return response.data.consultantSuggestions || [];
  } catch {
    return [];
  }
};

export const getMetadataCounts = async () => {
  try {
    const response = await axios.post(
      `${API_BASE}GetMasterdataCounts`  ,
      { token: getToken() },
      { headers }
    );
    return response.data.data || [];
  } catch {
    return [];
  }
};

export const getRoles = async () => {
  try {
    const response = await axios.post(
      `${API_BASE}GetRoles`,
      {
        token: getToken(),
        rolesFor: "Employee"
      },
      { headers }
    );
    return response.data.roles || [];
  } catch {
    return [];
  }
};

//Harshada Bhavsar (21/02/2026)
// Get Job Description
export const viewJobDescription = (JobDescriptionPath ) => {
  const employeeToken = Cookies.get("employeeToken");
  const consultantToken = Cookies.get("ConsultantToken"); 
  
  const token = employeeToken || consultantToken;
  return `${API_BASE}JobDescription/${encodeURIComponent(
    JobDescriptionPath 
  )}/${token}`;
};

export const getRoleCategory = async () => {
  try {
    const response = await axios.get(`${API_BASE}GetRoleCategory`);
    return response.data.roleCategory || [];

  } catch (error) {
    return [];
  }
};

export const getAllJobLocations = async () => {
  try {
    const response = await axios.get(`${API_BASE}GetAllJobLocation`);
    return response.data.allJobLocations || [];

  } catch (error) {
    return [];
  }
};

export const GetProfile = async (grade, department) => {
  try {
    const response = await axios.post(
      `${API_BASE}GetProfile`,
      {
        grade,
        department
      },
      { headers }
    );

    return response.data.profiles || [];
  } catch {
    return [];
  }
};
